import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { AbstractService } from "../../core/AbstractService";
import { ParametreRequest } from "../../data/http/requests/setting.req";
import { ParametreResponse } from "../../data/http/responses/setting.res";
import { ApiResponse } from "../../data/http/responses/apiresponse.response";
import { env } from "../../../env/env";
import { Injectable } from "@angular/core";
import { AppService } from "../../core/app.service";

@Injectable({
    providedIn: 'root'
})
export class SettingService extends AbstractService<ParametreRequest, ParametreResponse> {
    constructor(http: HttpClient, appService: AppService) {
        super(`${env.apiUrl}parametre`, http, null, appService);
    }

    getByAppIdAndType(appId: string, typeCode: string): Observable<ApiResponse<ParametreResponse>> {
        return this.http.get<ApiResponse<ParametreResponse>>(
            `${this.baseUrl}/by-type/${typeCode}`,
            { headers: this.getHeaders() }
        );
    }

    refreshBrand(appId: string): void {
        this.getByAppIdAndType(appId, 'SYSTEM_CONFIG').subscribe({
            next: (res) => this.brandCache.next(res.data ?? null),
            error: (err) => console.error('Échec rafraîchissement branding système', err),
        });
    }

    private brandCache = new BehaviorSubject<ParametreResponse | null>(null);
    private brandLoaded = false;

    getSystemBrand(appId: string): Observable<ParametreResponse | null> {
        if (this.brandLoaded) {
            return this.brandCache.asObservable();
        }
        this.brandLoaded = true;
        this.getByAppIdAndType(appId, 'SYSTEM_CONFIG').subscribe({
            next: (res) => this.brandCache.next(res.data ?? null),

            error: (err) => {
                console.error('Échec chargement branding système', err);
                this.brandCache.next(null);
            },
        });
        return this.brandCache.asObservable();

    }

    /**
     * Construit l'URL complète d'affichage d'un logo à partir du chemin brut
     * stocké côté back (ex. "logo.png"). Contrat back → front, cf. §2 CONTEXT_CENTRAL :
     * le back ne renvoie jamais qu'un nom de fichier logique, jamais une URL complète.
     * Point unique de construction, à utiliser par tout composant affichant le logo
     * (SidebarComponent, InfoSystemeComponent, ...).
     */
    buildLogoUrl(logoPath: string | null | undefined): string | null {
        return logoPath
            ? `${env.filesBaseUrl}/v0.1/api/simo/images/${logoPath}`
            : null;
    }
}